import * as bootstrap from "bootstrap";

class OffcanvasService {
  reset(element) {
    this.css = [];
    this.offcanvasTarget = element;
    this.titleTarget = element.querySelector(".offcanvas-title");
    this.offcanvas = new bootstrap.Offcanvas(this.offcanvasTarget);
  }

  show(title, css = "offcanvas-end offcanvas_large") {
    this.titleTarget.textContent = title;
    this.offcanvasTarget.classList.remove(...this.css);
    this.offcanvasTarget.classList.add(...(this.css = css.split(" ")));

    // setTimeout is to fix initial animation because of the dynamic classes
    setTimeout(() => this.offcanvas.show(), 200);
  }

  hide() {
    this.offcanvas.hide();
  }
}

export default window.OffcanvasService = new OffcanvasService();
